import { ThunkAction } from 'redux-thunk';
import { State as LoginState } from '@telstra-connect/login';
import {
    loadCasesStart,
    loadCasesSuccess,
    loadCasesError,
} from '../actions/load-cases-int';
import { ICasesCCDResponse } from '../state/cases-int';
import { Http } from '@telstra-connect/utils';

export function loadCasesCCD(type: string, cidn: string): ThunkAction<void, LoginState.ISignInState, void> {
    return (dispatch, getState) => {
        dispatch(loadCasesStart());
        const renderCategory = {
            'Order enquiry': 'Order_Enquiry',
            'Billing enquiry': 'Billing_Enquiry'
        }
        return Http.get<ICasesCCDResponse>({
            url: `/ccd/v1/cases?category=${renderCategory[type]}`,
            customHeaders: {
                'company-id': cidn
            },
            state: getState(),
        }).then((result) => {
            const cases = result && Array.isArray(result) ? result : [];
            const checkedResult: ICasesCCDResponse = {
                cases
            };
            dispatch(loadCasesSuccess(checkedResult));
        }).catch((error) => {
            dispatch(loadCasesError('Error loading cases list'));
        });
    };
}
